// extracted by mini-css-extract-plugin
module.exports = {"headerStyles":"main_headerStyles__2VVrK","mainWrapper":"main_mainWrapper__fRhSV","footerInfoWrap":"main_footerInfoWrap__qBYLQ"};